import { CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE_CODE_MAP, CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE, } from "./constants";
export var getTranslatedCreateModalHelpURL = function () {
    // Get the browser language
    var browserLanguage = navigator.language || "en";
    if (!browserLanguage) {
        return CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE;
    }
    // Get the mapped language code else default to english
    if (browserLanguage &&
        browserLanguage in CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE_CODE_MAP) {
        var languageCode = CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE_CODE_MAP[(browserLanguage)];
        return CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE.replace(CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE_CODE_MAP.en, languageCode);
    }
    return CREATE_TEMPLATE_FROM_PROJECT_HELP_PAGE;
};
